module.exports = __webpack_public_path__ + "static/media/site.053100cb.webmanifest";